import React, { useState } from 'react';
import { AddLevelBody, UpdateLevelBody } from '@loyalty/shared-common/gamification-api-client';
import { Box, Button, Tooltip } from '@mui/material';
import { Feature } from '@loyalty/shared-common';
import { QlfPlaceholder, colorPalette } from '@qualifio/ui-commons';
import { useTranslation } from 'react-i18next';
import { EditLevelsConfig } from './EditLevelsConfig';
import { LevelForm } from './LevelForm';
import { LevelsConfigDialog } from '../config/LevelsConfigDialog';
import { QlfPlaceholderIcon } from '../../../shared/qlf-placeholder-icon/QlfPlaceholderIcon';
import { levelsIcon } from '../../../shared/icons';
import { useFeatures } from '../../../features/FeaturesContext';
import { useLevels } from '../../LevelsContext';
import { useLevelsConfig } from '../../LevelsConfigContext';

function ConfigureLevel() {
  const { createLevel } = useLevels();
  const { levelsConfig } = useLevelsConfig();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { features } = useFeatures();
  const { write: levelWrite } = features[Feature.LEVEL];

  return levelsConfig ? (
    <Tooltip title={levelWrite ? '' : t('shared.action.permission.required')} placement="left">
      <Box textAlign="center" pt={3}>
        <Button
          disabled={!levelWrite}
          color="primary"
          onClick={createLevel}
          id="letsstart-button-id"
        >
          {t('levels.add.title')}
        </Button>
        <LevelsConfigDialog open={open} setOpen={setOpen} />
      </Box>
    </Tooltip>
  ) : (
    <Tooltip title={levelWrite ? '' : t('shared.action.permission.required')} placement="left">
      <Box textAlign="center" pt={3}>
        <Button
          disabled={!levelWrite}
          color="primary"
          onClick={() => setOpen(true)}
          id="letsstart-button-id"
        >
          {t('levels.states.empty.button')}
        </Button>
        <LevelsConfigDialog open={open} setOpen={setOpen} />
      </Box>
    </Tooltip>
  );
}

export function LevelDetails(): React.ReactElement {
  const { levels, selectedLevel, addLevel, updateLevel } = useLevels();
  const { t } = useTranslation();
  const { levelsConfig } = useLevelsConfig();

  const handleSave = async (level: AddLevelBody | UpdateLevelBody) => {
    if (level['isNew']) {
      addLevel(level as AddLevelBody);
    } else {
      updateLevel(level);
    }
  };
  return (
    <Box display="flex" flexDirection="column" height="100%">
      {levelsConfig && (
        <Box
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            zIndex: 99,
          }}
          display="flex"
          justifyContent="flex-end"
          mb={1}
        >
          <EditLevelsConfig />
        </Box>
      )}
      {levels.length === 0 || !selectedLevel ? (
        <QlfPlaceholder
          icon={<QlfPlaceholderIcon icon={levelsIcon} color={colorPalette.grey.main} />}
          primaryText={t('levels.states.empty.title')}
          secondaryText={t('levels.states.empty.description')}
          actions={<ConfigureLevel />}
        />
      ) : (
        <LevelForm key={selectedLevel.id} level={selectedLevel} onSubmit={handleSave} />
      )}
    </Box>
  );
}
